<!--申请结算款项: 核收或核退 -->
<template>
  <div v-loading="loading">
    <el-form
      :rules="rules"
      :model="submitData"
      label-width="120px"
      ref="submitData"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '核收金额' : '核付金额'">
              <el-input
                type="number"
                v-model="CollectionAmount"
                disabled
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '已收金额' : '已付金额'">
              <el-input type="number" v-model="Paid" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="结算方式" prop="PayType">
              <el-select
                v-model="submitData.PayType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in payWayList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '实收金额' : '实付金额'">
              <el-input
                type="number"
                v-model="submitData.NowPay"
                :min="0"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '收款日期' : '付款日期'">
              <el-date-picker
                v-model="submitData.PayTime"
                align="right"
                type="date"
                placeholder="选择日期"
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content bg-purple">
            <el-form-item label="备注">
              <el-input v-model="submitData.Remark"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn-ctn">
      <el-button size="small" class="search-btn" @click="cancel()"
        >取消</el-button
      >
      <el-button
        size="small"
        class="search-btn btn-primary"
        @click="submitForm()"
        >提交</el-button
      >
    </div>
    <div class="table-ctn">
      <el-table
        :header-cell-style="{ background: '#F2F6FC' }"
        :data="receiptRecords"
        show-summary
        :summary-method="getSummaries_apply"        
        border
        style="width: 100%; margin-bottom: 10px; margin-top: 10px;overflow:hidden"
      >
        <el-table-column
          show-overflow-tooltip
          width="190px"
          prop="PayCode"
          label="流水号"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100px"
          prop="SumPayable"
          label="核余总金额"
        ></el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          width="100px"
          prop="AlreadyPaid"
          label="已收款金额"
        ></el-table-column> -->
        <el-table-column
          show-overflow-tooltip
          width="150px"
          prop="NowPay"
          :label="Type == 0 ? '实收金额' : '实付金额'"
        ></el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          width="120px"
          prop="Unpaid"
          label="剩余申请金额"
        ></el-table-column> -->
        <el-table-column
          show-overflow-tooltip
          width="80px"
          prop="PayTypeName"
          label="结算方式"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80px"
          prop="ApplyName"
          label="申请人"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="160px"
          prop="CreateTime"
          label="申请时间"
        ></el-table-column>
         <el-table-column
          show-overflow-tooltip
          width="100px"
          prop="PayTime"
          :label="Type == 0 ? '收款日期' : '付款日期'"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="180px"
          prop="Remark"
          label="备注"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" width="60px">
          <template slot-scope="scope">
            <div
              class="ops-ctn"
              v-if="!scope.row.IsConfirm && !scope.row.IsCancel"
            >
              <el-button
                title="撤销"
                size="mini"
                type="text"
                @click="cancelPayRecord(scope.row.Id)"
                >撤销</el-button
              >
            </div>
            <div
              class="ops-ctn"
              v-else-if="!scope.row.IsConfirm && scope.row.IsCancel"
            >
              已撤销
            </div>
            <div
              class="ops-ctn"
              v-else-if="scope.row.IsConfirm && !scope.row.IsCancel"
            >
              已确认
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["RecordId", "Amount", "Type", "Paid"],
  components: {},
  data() {
    return {
      loading: false,
      receiptRecords: [],
      payWayList: [],
      CollectionAmount: 0,
      submitData: {
        RecordId: this.RecordId,
        PayType: "",
        Remark: "",
        NowPay: 0,
        Type: this.Type,
        PayTime:""
      },
      cancelPayRecordData: {
        Id: "",
        OperateType: 0,
      },
      rules: {
        PayType: [{ required: true, message: "该项必填", trigger: "blur" }],
      },
      isEdit: false,
    };
  },
  created: function() {
    var aData = new Date();
    this.submitData.PayTime =
      aData.getFullYear() + "-" + (aData.getMonth() + 1) + "-" + aData.getDate();
  },
  mounted() {
    this.getPay();
    if (this.Amount == 0) {
      this.$util.warningMsg("结款金额必须不能等于0");
    } else this.CollectionAmount = Math.abs(this.Amount);


    this.getRecords();
  },
  methods: {
    cancel() {
      this.$emit("closeSettleUp", this.isEdit);
    },
    submitForm() {
      if (this.submitData.NowPay == 0) {
        this.$util.warningMsg("申请的实收/付金额必须不能等于0");
        return;
      }
      if (this.submitData.NowPay < 0) {
        this.$util.warningMsg("申请的实收/付金额必须不能小于0");
        return;
      }
      this.$refs["submitData"].validate((valid) => {
        if (valid) {
          this.$confirm(
            "您确认要提交此款项的申请吗？一旦提交将生成待确认款项！",
            "提示",
            {
              confirmButtonText: "确定提交",
              cancelButtonText: "取消",
              type: "warning",
              center: false,
            }
          ).then(() => {
            this.loading = true;
            this.$util
              .axiosPost({
                url: "/api/RevenueManagement/SettleUpButNeedConfirm",
                data: this.submitData,
                hideLoading: true,
              })
              .then((res) => {
                this.$util.successMsg("申请成功");
                this.isEdit = true;
                this.getRecords();
              })
              .finally(() => {
                this.loading = false;
              });
            })
        .catch(() => {});          
        } else {
          return false;
        }
      });      

    },
    //  结算方式
    getPay() {
      this.$util.getPay(1).then((data) => {
        this.payWayList = data;
      });
    },
    getRecords() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/RevenueManagement/GetStApplyRecords",
          data: {
            RecordId: this.RecordId,
          },
          hideLoading: true,
        })
        .then((res) => {
          let data = res.data;
          this.receiptRecords = data;
        })
        .finally((err) => {
          this.loading = false;
        });
    },
    cancelPayRecord(id) {
      if (id) {
        this.$confirm("是否撤销该条款项申请？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: false,
        })
          .then(() => {
            this.loading = true;
            this.$util
              .axiosPost({
                url: `/api/RevenueManagement/CancelApplyRecords?RecordId=${id}`,
                hideLoading: true,
              })
              .then((res) => {
                this.$util.successMsg("撤销成功");
                this.isEdit = true;
                this.getRecords();
              })
              .finally((err) => {
                this.loading = false;
              });
          })
          .catch(() => {});
      } else {
        this.$util.warningMsg("请选择有效的款项");
      }
    },
    getSummaries_apply(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index===3){
          // let totalAmount=0
          // if(data.length>0)
          //   totalAmount=Number(data[0].SumPayable);
          // let applyTotal= data.reduce((prev, curr) => {
          //   if(curr.IsCancel)
          //     return prev;
          //   else
          //     return prev +Number(curr.ApplyPay);
          // }, 0) ;         
          // sums[index] = '剩余可申请：'+(totalAmount>applyTotal?totalAmount-applyTotal:0).toFixed(2);         
           sums[index] =""; 
          return;
        }else if (index===2){
          let sum=data.reduce((prev, curr) => {
            if(curr.IsCancel||!curr.IsConfirm)
              return prev;
            else
              return prev +Number(curr.NowPay);
          }, 0)
          sums[index] =(this.Type == 0? '已收：':'已付：')+sum.toFixed(2);             
          return;
        }
        else{
          sums[index] ="";
          return;
        }
      });
      return sums;
    },     
  },
};
</script>
<style lang="less" scoped>
.dialog-content {
  margin: 5px;
}
.btn-ctn {
  text-align: right;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
}
// // 此处样式 是解决table表格出现横向滚动条时， 合并栏在滚动条下方的问题
// /deep/.el-table{
//     overflow: auto;
// }
// /deep/.el-table__header-wrapper, 
// /deep/.el-table__body-wrapper, 
// /deep/.el-table__footer-wrapper{
//          overflow:visible;     
//    }
//  /deep/.el-table__body-wrapper{
//    overflow-x:visible !important;
//  }
//  /* 这个是为了解决前面样式覆盖之后伪类带出来的竖线 */
// /deep/.el-table::after{
//    position: relative !important;
// }

</style>
